<template>
    <div class="min-h-screen bg-gradient-to-b from-white to-gray-100 flex items-center justify-center px-6">
      <div class="text-center max-w-2xl">
        <h1 class="text-3xl sm:text-5xl md:text-3xl font-bold text-gray-900 mb-6 leading-tight">
          Innovating Air Purification, the Indian Way
        </h1>
        <p class="text-lg text-gray-600 text-justify">
          We're developing a range of air purification solutions that blends advanced nanofiber technology with artificial intelligence to address everyday needs of people in India.
          <br><br>
          Every circuit, filter, and line of code is crafted to tackle India’s unique climate, power conditions, and living spaces — proudly designed in India@Hyderabad to meet the air quality needs of both Indian villages and cities.
          <br><br>
          Stay tuned for a breath of fresh, healthier air.
        </p>
      </div>
    </div>
  </template>
  
  <script>
  export default {
    name: 'PreLaunch'
  }
  </script>